import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
} from 'redux';
import auth from 'reducers/auth';
import app from 'reducers/app';
import applications from 'reducers/applications';
import organisations from 'reducers/organisations';
import quotes from 'reducers/quotes';
import loans from 'reducers/loans';
import xeroSnapshot from 'reducers/xero_snapshots';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

const reducer = combineReducers({
  auth,
  app,
  organisations,
  applications,
  quotes,
  loans,
  xeroSnapshot,
  form: formReducer
});

export const configureStore = () => {
  return compose(
    applyMiddleware(thunk),
  )(createStore)(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
};



// WEBPACK FOOTER //
// ./src/utils/store.js